import React from 'react';

export interface NCContextProps {
  DrawerComponent?: React.ComponentType<any>;
  PageComponent?: React.ComponentType<any>;
  isStandalonePage?: boolean;
}

export const NCContext = React.createContext<NCContextProps>({});
NCContext.displayName = 'NCContext';
